<template lang="html">

  <!-- <v-icon small>mdi-cart</v-icon>
  <v-icon small>mdi-link-variant</v-icon>
  <v-icon small>mdi-arrow-left-bold-hexagon-outline</v-icon>
  <v-icon small>mdi-selection-search</v-icon>
  <v-icon small>mdi-contain</v-icon> -->
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        small
        v-bind="attrs"
        v-on="on"
        class="mr-1"
      >
        {{ iconName }}
      </v-icon>
    </template>
    <span>{{ type }}</span>
  </v-tooltip>

</template>

<script>

export default {
  name: 'CheckIcon',
  props: {
    type: { type: String, required: true }
  },
  computed: {

    iconName () {
      return {
        http_status: 'mdi-link-variant',
        root_redirect: 'mdi-arrow-left-bold-hexagon-outline',
        product_availability: 'mdi-cart',
        effective_url: 'mdi-contain',
        http_body: 'mdi-selection-search'
      }[this.type]
    }

  }
}
</script>

<style lang="css" scoped>
</style>
